import React from 'react';
export function createDefs(useId) {
  return /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "".concat(useId, "-a"),
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: "0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "".concat(useId, "-b"),
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: "0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%"
  })));
}
export function createShadows(_ref) {
  var useId = _ref.useId,
    transform = _ref.transform;
  return /*#__PURE__*/React.createElement("g", {
    opacity: ".2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(useId, "-a)"),
    d: "M88.1 38.5c-4.4 7 139.3 80.9 147.1 80.5 7.9-.4 296.6-88.6 300.7-95.1C540 17.4 333.2 5.6 323.4 6c-9.7.5-230.9 25.4-235.3 32.5z",
    transform: transform
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(useId, "-a)"),
    d: "M0 59.4C1.6 68.9 313.7 119 330.2 119c16.6 0 163.6-93.5 162.8-98.6-.8-5-159.6-18.2-170.3-17.4C312.1 3.8-1.6 49.8 0 59.4z",
    transform: transform
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(useId, "-b)"),
    d: "M52 50.5c-.5 9 244 35.4 259 34.5 14.9-1 225.7-55.6 226-61 .3-5.4-207-24.6-217.5-24C308.8.7 52.5 41.4 52 50.5z",
    transform: transform
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(useId, "-b)"),
    d: "M49 48.8C44.9 62.3 298.3 73.8 313 73c14.6-.8 215.7-41 217-45.3C531.5 23.3 345.3-.6 334.2 0 322.9.6 53.3 35.3 49 48.8z",
    transform: transform
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(useId, "-b)"),
    d: "M94 40.8C89.5 53 287.3 86 309.8 85 332 84 500.5 26.5 502 22.6c1.5-3.8-157.2-15-168.3-14.6C322.5 8.5 98.8 28.6 94 40.8z",
    transform: transform
  }));
}